'use es6';

import { combineReducers } from 'redux';
import emptyFunction from 'react-utils/emptyFunction';
import networkErrors from 'MeetingsLib/redux/reducers/networkErrors';
import branding from 'MeetingsLib/redux/reducers/branding';
import bookingLifecycle from 'MeetingsLib/redux/reducers/bookingLifecycle';
import portalId from 'MeetingsLib/redux/reducers/portalId';
import portalAuth from 'MeetingsLib/redux/reducers/portalAuth';
import emailFormState from 'MeetingsLib/redux/reducers/emailFormState';
import initialFormState from 'MeetingsLib/redux/reducers/initialFormState';
import stagedFormState from 'MeetingsLib/redux/reducers/stagedFormState';
import formState from 'MeetingsLib/redux/reducers/formState';
import bookInfo from 'MeetingsLib/redux/reducers/bookInfo';
import eventDetails from 'MeetingsLib/redux/reducers/eventDetails';
import isSalesStarter from 'MeetingsLib/redux/reducers/isSalesStarter';
import calendarProvider from 'MeetingsLib/redux/reducers/calendarProvider';
import profile from 'MeetingsLib/redux/reducers/profile';
import userMessage from 'MeetingsLib/redux/reducers/userMessage';
import userTimezone from 'MeetingsLib/redux/reducers/userTimezone';
import requestStatus from 'MeetingsLib/redux/reducers/requestStatus';
import activeLocale from 'MeetingsLib/redux/reducers/activeLocale';
import companyName from 'MeetingsLib/redux/reducers/companyName';
import stagedLegalConsentResponses from 'MeetingsLib/redux/reducers/stagedLegalConsentResponses';
import legalConsentResponses from 'MeetingsLib/redux/reducers/legalConsentResponses';
import troubleshooting from 'MeetingsLib/redux/reducers/troubleshooting';
import legitimateInterestConfirmed from 'MeetingsLib/redux/reducers/legitimateInterestConfirmed';
import recaptcha from 'MeetingsLib/redux/reducers/recaptcha';
export default combineReducers({
  requestStatus: requestStatus,
  bookingLifecycle: bookingLifecycle,
  networkErrors: networkErrors,
  branding: branding,
  portalId: portalId,
  portalAuth: portalAuth,
  emailFormState: emailFormState,
  initialFormState: initialFormState,
  stagedFormState: stagedFormState,
  formState: formState,
  bookInfo: bookInfo,
  eventDetails: eventDetails,
  isSalesStarter: isSalesStarter,
  calendarProvider: calendarProvider,
  profile: profile,
  userMessage: userMessage,
  userTimezone: userTimezone,
  activeLocale: activeLocale,
  companyName: companyName,
  stagedLegalConsentResponses: stagedLegalConsentResponses,
  legalConsentResponses: legalConsentResponses,
  troubleshooting: troubleshooting,
  legitimateInterestConfirmed: legitimateInterestConfirmed,
  recaptcha: recaptcha,
  trackingParams: function trackingParams() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return state;
  },
  prefilledCustomFormFields: function prefilledCustomFormFields() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return state;
  },
  userSlug: function userSlug() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return state;
  },
  embedded: function embedded() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return state;
  },
  isRescheduling: function isRescheduling() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return state;
  },
  meetingChangeId: function meetingChangeId() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return state;
  },
  forceOffline: function forceOffline() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return state;
  },
  forcePropertyForm: function forcePropertyForm() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return state;
  },
  queryParams: function queryParams() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return state;
  },
  currentTime: function currentTime() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return state;
  },
  initTrackingForMeetings: function initTrackingForMeetings() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return state;
  },
  onSuccess: function onSuccess() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyFunction;
    return state;
  },
  onFailure: function onFailure() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyFunction;
    return state;
  },
  forceMobile: function forceMobile() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return state;
  },
  parentPageHSAnalyticsInfo: function parentPageHSAnalyticsInfo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return state;
  },
  allowTroubleshootMode: function allowTroubleshootMode() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return state;
  },
  allowRedirect: function allowRedirect() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return state;
  },
  disablePrefill: function disablePrefill() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return state;
  }
});